import { render, staticRenderFns } from "./SurveyThankYou.vue?vue&type=template&id=38c0274e&scoped=true&"
import script from "./SurveyThankYou.vue?vue&type=script&lang=js&"
export * from "./SurveyThankYou.vue?vue&type=script&lang=js&"
import style0 from "./SurveyThankYou.vue?vue&type=style&index=0&id=38c0274e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0274e",
  null
  
)

export default component.exports